import { Stack, usePathname } from 'expo-router';
import { useEffect } from 'react';
import { Platform, View } from 'react-native';
import { StyleSheet } from 'react-native';
import { SystemBars } from 'react-native-edge-to-edge';

import { useGetUserPurchasedShows } from '@/api/hooks/showHooks';
import GoBackButton from '@/components/buttons/GoBackButton';
import DotsLoader from '@/components/DotsLoader';
import GuardWrapper from '@/components/GuardWrapper';
import Title from '@/components/Title';
import PlatformContainer from '@/components/web/PlatformContainer';
import { i18n } from '@/utils/i18n';

const ShowLayout = () => {
  const pathname = usePathname();
  const { data: userPurchsaedShows, isPending } = useGetUserPurchasedShows();

  const userBuyedShow = userPurchsaedShows !== undefined && userPurchsaedShows.length !== 0;

  const segments = pathname.split('/').filter(Boolean);
  const fullWidth =
    segments[0] === 'show' && segments.length === 2 && segments[1] !== 'giftSeries' && segments[1] !== 'giftSummary';

  useEffect(() => {
    const entry = SystemBars.pushStackEntry({
      style: {
        statusBar: 'light',
        navigationBar: 'dark'
      }
    });

    return () => {
      SystemBars.popStackEntry(entry);
    };
  }, []);

  if (isPending) {
    return (
      <View style={styles.loaderContainer}>
        <DotsLoader color="white" />
      </View>
    );
  }

  return (
    <GuardWrapper canAccess={['INDIVIDUAL']} extraCondition={userBuyedShow}>
      <PlatformContainer
        containerCustomClassname="bg-black"
        contentCustomClassnames={`flex bg-black ${fullWidth ? 'max-w-full' : ''}`}>
        <Stack
          screenOptions={{
            headerShadowVisible: false,
            headerBackVisible: false
          }}>
          <Stack.Screen
            name="index"
            options={{
              headerTintColor: 'black',
              contentStyle: styles.content,
              headerBackground: () => <View style={styles.headerBackground} />
            }}
          />
          <Stack.Screen
            name="[episodeId]"
            options={{
              headerTintColor: 'black',
              contentStyle: styles.content,
              headerLeft: () => (Platform.OS !== 'web' ? <GoBackButton iconColor="white" /> : null),
              headerBackground: () => <View style={styles.headerBackground} />
            }}
          />
          <Stack.Screen
            name="giftSeries"
            options={{
              headerTintColor: 'black',
              contentStyle: styles.content,
              headerLeft: () => <GoBackButton iconColor="white" />,
              headerTitle: () => <Title label={i18n.t('giftShows.gift_series_title')} colorVariant="alt" />,
              headerBackground: () => <View style={styles.headerBackground} />
            }}
          />
          <Stack.Screen
            name="giftSummary"
            options={{
              headerTintColor: 'black',
              contentStyle: styles.content,
              headerLeft: () => <GoBackButton iconColor="white" />,
              headerTitle: () => <Title label={i18n.t('giftShows.gift_series_title')} colorVariant="alt" />,
              headerBackground: () => <View style={styles.headerBackground} />
            }}
          />
        </Stack>
      </PlatformContainer>
    </GuardWrapper>
  );
};

const styles = StyleSheet.create({
  loaderContainer: {
    flex: 1,
    backgroundColor: 'black',
    justifyContent: 'center',
    alignItems: 'center'
  },

  headerBackground: {
    flex: 1,
    backgroundColor: 'black'
  },

  content: {
    flex: 1,
    backgroundColor: 'black'
  }
});

export default ShowLayout;
